import {AnimatePresence, motion} from 'motion/react'
import {MetaTile} from 'quickstart/components/tizra/MetaTile'
import {logger, meta} from 'tizra'
import type {BrowseGalleryProps} from '..'
import {getMotionProps} from './motion-props'
import {useInfiniteBrowse} from './useInfiniteBrowse'

const log = logger('BrowseGallery/tiles')

const MotionTile = motion.create(MetaTile)

export const TilesGallery = ({
  maxItems,
  search,
  size,
  imageCropping,
  imageFocus,
  slots,
}: BrowseGalleryProps) => {
  const {bottomRef, items, spinner, spinnerWrapperStyle} = useInfiniteBrowse({
    maxItems,
    search,
  })

  const motionProps = getMotionProps()

  return (
    <div style={spinnerWrapperStyle}>
      <MetaTile.Group size={size} realignImages={imageCropping === 'full'}>
        <AnimatePresence mode="popLayout">
          {items?.map(r => (
            <MotionTile
              key={meta.key(r)}
              metaObj={r}
              imageCropping={imageCropping}
              imageFocus={imageFocus}
              size={size}
              slots={slots}
              {...motionProps}
            />
          ))}
        </AnimatePresence>
      </MetaTile.Group>
      <div ref={bottomRef} />
      {spinner}
    </div>
  )
}
